import { render, staticRenderFns } from "./ConfirmArchiveUserModal.vue?vue&type=template&id=d13e5818&scoped=true&"
import script from "./ConfirmArchiveUserModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmArchiveUserModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmArchiveUserModal.vue?vue&type=style&index=0&id=d13e5818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13e5818",
  null
  
)

export default component.exports